import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { ManageDiscountCategoryDetailPayload, ManageDiscountCategoryDetailStatusPayload } from './discount-slabs.types';

export interface ManageDiscountCategoryPayload {
  categoryId: string;
  categoryName: string;
  categoryDescription: string;
}

export interface ManageCategoryStatusPayload {
  categoryId: string;
  status: string;
}

export interface AssignDiscountCategoryPayload {
  locationId: string;
  clubId: string;
  newDiscountCategoryId: string;
}

const manageDiscountCategory = (client: AxiosInstance) => async (payload: ManageDiscountCategoryPayload) => {
  return (
    await client.post<{ message: string; data: ManageDiscountCategoryPayload }>(
      API_ROUTES.MANAGE_DISCOUNT_CATEGORY,
      payload,
    )
  ).data;
};

const manageCategoryStatus = (client: AxiosInstance) => async (payload: ManageCategoryStatusPayload) => {
  return (
    await client.post<{ message: string; data: ManageCategoryStatusPayload }>(
      API_ROUTES.MANAGE_CATEGORY_STATUS,
      payload,
    )
  ).data;
};

const assignDiscountCategory = (client: AxiosInstance) => async (payload: AssignDiscountCategoryPayload) => {
  return (
    await client.post<{ message: string; data: AssignDiscountCategoryPayload }>(
      API_ROUTES.ASSIGN_DISCOUNT_CATEGORY,
      payload,
    )
  ).data;
};

const manageDiscountCategoryDetail =
  (client: AxiosInstance) => async (payload: ManageDiscountCategoryDetailPayload) => {
    return (
      await client.post<{ message: string; data: ManageDiscountCategoryDetailPayload }>(
        API_ROUTES.DISCOUNT_CATEGORY_DETAIL_MANAGE,
        payload,
      )
    ).data;
  };

const manageCategoryDetailStatus =
  (client: AxiosInstance) => async (payload: ManageDiscountCategoryDetailStatusPayload) => {
    return (
      await client.post<{ message: string; data: ManageDiscountCategoryDetailStatusPayload }>(
        API_ROUTES.DISCOUNT_CATEGORY_DETAIL_STATUS_MANAGE,
        payload,
      )
    ).data;
  };

export const discountCategoryMutations = {
  manageDiscountCategory,
  manageCategoryStatus,
  assignDiscountCategory,
  manageDiscountCategoryDetail,
  manageCategoryDetailStatus,
};
